import { Component, Input, OnInit } from '@angular/core';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cv-evaluation',
  templateUrl: './cv-evaluation.component.html',
  styleUrls: ['./cv-evaluation.component.css'],
})
export class CvEvaluationComponent implements OnInit {
  @Input() selectedCv: any;

  cvScores: any = {};
  scanResultData: any = null;
  jobRanking: any = null;
  contentData: any;
  imagePath = environment.apiUrl;

  // tracks which skill lists are open
  openLists: Record<string, boolean> = {};

  constructor(
    private content: FetchDataService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.scanResultData = this.selectedCv?.formatResponse ?? null;
    this.jobRanking     = this.selectedCv?.jobRankingResponse ?? null;
   if (this.scanResultData) {
      const manualScore = this.calculateScore(this.scanResultData);
      this.cvScores.total = this.jobRanking?.overallScore != null
        ? parseFloat(((this.jobRanking.overallScore + manualScore) / 2).toFixed(1))
        : manualScore;
      this.cvScores.headline   = this.calculateScore(this.scanResultData.headline);
      this.cvScores.format     = this.calculateScore(this.scanResultData.format);
      this.cvScores.summary    = this.calculateScore(this.scanResultData.summary);
      this.cvScores.experience = this.calculateScore(this.scanResultData.experience);
      this.cvScores.education  = this.calculateScore(this.scanResultData.education);
    }

    this.loadContent(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadContent(event.lang);
    });
  }

  toggleList(key: string): void {
    this.openLists[key] = !this.openLists[key];
  }

  getCheckIcon(fieldName: string): string {
    const fieldValue = this.findFieldValue(this.scanResultData, fieldName);
    return fieldValue === 1
      ? 'assets/icon/right check.png'
      : 'assets/icon/wrong-check.png';
  }

  private findFieldValue(data: any, fieldName: string): any {
    if (data === null || data === undefined) return undefined;
    if (Array.isArray(data)) {
      for (const item of data) {
        const result = this.findFieldValue(item, fieldName);
        if (result !== undefined) return result;
      }
    } else if (typeof data === 'object') {
      for (const key in data) {
        if (key === fieldName) return data[key];
        const result = this.findFieldValue(data[key], fieldName);
        if (result !== undefined) return result;
      }
    }
    return undefined;
  }

  loadContent(lang: string): void {
    this.content.getContentData(lang, 'scan-result').subscribe({
      next: (data) => { this.contentData = data; },
      error: (error) => { console.log(error); },
    });
  }

  calculateScore(data: any): number {
    let total = 0;
    let count = 0;
    function traverse(section: any) {
      if (Array.isArray(section)) {
        section.forEach((item) => traverse(item));
      } else if (typeof section === 'object' && section !== null) {
        Object.values(section).forEach((value) => {
          if (typeof value === 'number') { total += value; count++; }
          else { traverse(value); }
        });
      }
    }
    traverse(data);
    return count === 0 ? 0 : parseFloat(((total / count) * 100).toFixed(1));
  }

  getCircleDash(score: number): string {
    const circumference = 2 * Math.PI * 15.9;
    return `${(score / 100) * circumference} ${circumference}`;
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  downloadFile(path: string) {
    const link = document.createElement('a');
    link.href = this.imagePath + path;
    link.download = path.split('/').pop() || 'download';
    link.click();
  }
}